<template>
  <svg
    viewBox="226.69000244140625 196.85000610351562 546.6199951171875 606.300048828125"
    fill="currentColor"
    aria-hidden="true">
    <polygon points="226.83 411.15 501.31 803.15 623.31 803.15 348.82 411.15 226.83 411.15" />
    <polygon points="348.72 628.87 226.69 803.15 348.77 803.15 409.76 716.05 348.72 628.87" />
    <polygon points="651.23 196.85 440.28 498.12 501.32 585.29 773.31 196.85 651.23 196.85" />
    <polygon points="673.31 383.25 673.31 803.15 773.31 803.15 773.31 240.44 673.31 383.25" />
  </svg>
</template>
